<template>
  <div
    :class="[
      'gallery-img--wrap d-flex mr-3',
      { 'has-caption': imgCaption.length },
      { 'show-caption': showCaption },
    ]"
  >
    <img
      :src="imgSrc"
      :class="[
        'gallery-img',
        ,
        { 'has-item': img.item && isViewingNewOrderPage },
      ]"
      @click.stop="imgClick"
    />
    <div
      v-if="imgCaption.length"
      :class="['img-caption white--text px-3 py-2', { show: showCaption }]"
      @click.stop="toggleCaption"
      >{{ imgCaption }}</div
    >
    <div
      v-if="item && !img.hideName"
      :class="['img-name white--text title px-3 py-1', { show: showName }]"
    >
      {{ item.name }}
    </div>
    <div
      v-if="img.item && isViewingNewOrderPage"
      class="add-to-cart-wrap text-center"
    >
      <v-btn
        left
        small
        @click="addToCartClick"
        :class="[
          'mb-2 font-weight-bold mx-auto add-to-cart-btn blue--text text--darken-2',
          {
            oos:
              isOutOfStock || !getAvailabilities.length || stockRemaining == 0,
          },
        ]"
        :disabled="
          isOutOfStock || !getAvailabilities.length || stockRemaining == 0
        "
        color="white"
        >{{ isOutOfStock ? 'Sold Out' : 'Add to Cart' }}</v-btn
      >
    </div>
    <v-btn
      v-if="imgCaption.length"
      x-small
      absolute
      bottom
      right
      depressed
      class="ml-n4 mb-n1 px-1 caption-toggle-btn"
      @click="toggleCaption"
      :color="showCaption ? 'black' : 'white'"
    >
      <v-icon small :color="showCaption ? 'white' : 'black'">mdi-text</v-icon>
    </v-btn>
    <!-- <v-btn
      v-if="img.item"
      small
      absolute
      top
      right
      icon
      depressed
      class=""
      @click="toggleName"
      ><v-icon color="white">mdi-information</v-icon></v-btn
    > -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { GuestRoutes } from '@/constants/RouteNames'
import _get from 'lodash/get'
import _unescape from 'lodash/unescape'

export default {
  name: 'MenuGalleryImage',
  props: {
    img: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  components: {},
  data() {
    return {
      showCaption: false,
      showName: true,
      newOrderRoute: GuestRoutes.NEW_ORDER,
    }
  },
  computed: {
    ...mapGetters('itemAndSection', ['getItemById']),
    ...mapGetters('cart', ['getCartItemById']),
    ...mapGetters('availabilities', ['getAvailabilities']),

    imgSrc() {
      return this.img.url.replace(
        this.img.path,
        `f_auto,c_scale,h_420/${this.img.path}`
      )
    }, // imgSrc

    item() {
      if (!this.img.item) {
        return false
      }
      return this.getItemById(this.img.item)
    },
    isOutOfStock() {
      return (!this.unlimitedStock && this.itemStock < 1) || this.is86d
    }, // isOutOfStock

    unlimitedStock() {
      return _get(this.item, 'unlimited', false)
    }, // unlimitedStock

    itemStock() {
      if (this.unlimitedStock) return Infinity
      return _get(this.item, 'stock', Infinity)
    }, // itemStock

    is86d() {
      return _get(this.item, `86d`, false)
    }, // is86d

    quantityFromCart() {
      if (!this.item) return 0
      let cartItem = this.getCartItemById(this.item.id)
      return cartItem ? cartItem.quantity : 0
    }, // quantityFromCart

    stockRemaining() {
      return this.itemStock - this.quantityFromCart
    }, // stockRemaining

    imgCaption() {
      return _unescape(_get(this.img, 'caption', ''))
    }, // imgCaption
    isViewingNewOrderPage() {
      return this.$route.name === this.newOrderRoute
    },
  },
  methods: {
    ...mapActions('cart', ['highlightItem', 'addCartItem']),

    toggleCaption() {
      this.showCaption = !this.showCaption
    }, // toggleCaption
    toggleName() {
      this.showName = !this.showName
    }, // toggleName

    imgClick() {
      if (this.$gtag) {
        this.$gtag.event('gallery_img__click')
      }
      this.itemClick()
    }, // imgClick

    addToCartClick() {
      if (this.$gtag) {
        this.$gtag.event('gallery_img__add_to_cart_btn')
      }
      this.itemClick()
    }, // addToCartClick

    itemClick() {
      if (this.item && this.isViewingNewOrderPage) {
        if (!this.isOutOfStock && this.stockRemaining > 0) {
          this.addCartItem({
            ...this.item,
            quantity: this.quantityFromCart + 1,
          })
        }
        this.scrollToItem()
      } else if (this.imgCaption.length) {
        this.toggleCaption()
      }
    }, // itemClick

    scrollToItem() {
      this.$scrollTo(`#item-${this.item.id}`, { offset: -90 })
      this.highlightItem(this.item.id)
    }, // scrollToItem
  },
}
</script>

<style lang="scss" scoped>
.gallery-img--wrap {
  position: relative;
  // overflow: hidden;
  &.has-caption {
    .gallery-img {
      cursor: pointer;
    }
  }
  &.show-caption {
    .add-to-cart-btn {
      opacity: 0;
      visibility: hidden;
    }
    .caption-toggle-btn {
      transform: translateY(40px);
    }
    .img-caption {
      z-index: 2;
    }
  }
}
.gallery-img {
  height: 300px;
  max-height: 40vh;
  width: auto;
  &.has-item {
    cursor: pointer;
  }
}

.img-name {
  position: absolute;
  top: 0;
  left: 0;
  transition: all 0.5s ease-in-out;
  transform: translateY(-100%);
  opacity: 0;
  line-height: 1.2;
  background-color: rgba(black, 0.5);
  width: 100%;
  &.show {
    opacity: 1;
    transform: translateY(0%);
  }
}
.img-caption {
  position: absolute;
  bottom: 0;
  transition: all 0.3s;
  transform: translateY(100%);
  width: 100%;
  opacity: 0;
  background-color: transparent;
  cursor: pointer;
  &.show {
    opacity: 1;
    transform: translateY(0%);
    background-color: rgba(black, 0.4);
  }
}

.add-to-cart-wrap {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
.add-to-cart-btn {
  transition: opacity 0.3s;
  opacity: 1;
  &:not(.oos) {
    border: 1px solid #bbb;
  }
  &.oos.theme--light.v-btn.v-btn--disabled {
    background-color: lighten(black, 70) !important;
    color: lighten(black, 30) !important;
  }
}
.v-btn.caption-toggle-btn {
  min-width: 0;
}
</style>
